// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"1440px","desktop":"1024px","landscape":"812px","mobile":"600px","mobileSmall":"320px","footerMaxWith":"1110px"};